import React from 'react';

export default function LandingHero() {
  return (
    <section className="landing-hero" aria-labelledby="landing-hero-title">
      <div className="landing-hero-blobs" aria-hidden>
        <div className="landing-hero-blob landing-hero-blob--1" />
        <div className="landing-hero-blob landing-hero-blob--2" />
      </div>
      <div className="landing-hero-inner">
        <h1 id="landing-hero-title" className="landing-hero-title">
          <span className="landing-hero-title-muted">Monatliche</span>
          <br />
          Leuchtturm-Metrik
        </h1>
        <p className="landing-hero-lead">
          Erfasse Web- und ePaper-Abos transparent, pflege Produkt-Mappings zentral und
          behalte den Überblick über fehlende Daten.
        </p>
        <div className="landing-hero-cta">
   
          <a href="#anmeldung" className="btn btn-primary btn-lg landing-hero-cta-btn">
            Anmelden
          </a>
        </div>
      </div>
    </section>
  );
}
